import { createSlice } from '@reduxjs/toolkit';

export const productSlice = createSlice({
  name: 'product',
  initialState: {
    productById: null,
    productRecords: null,
    filterProductRecords: null,
    productRecordsByEmpId: []
  },
  reducers: {
    pushProductById: (state, action) => {
      state.productById = action.payload;
    },
    popProductById: (state) => {
      state.productById = null;
    },
    pushProductRecords: (state, action) => {
      state.productRecords = action.payload;
    },
    popProductRecords: (state) => {
      state.productRecords = null
    },
    pushFilterProductRecords: (state, action) => {
      state.filterProductRecords = action.payload;
    },
    popFilterProductRecords: (state) => {
      state.filterProductRecords = null
    },
    pushProductRecordsByEmpId: (state, action) => {
      state.productRecordsByEmpId = action.payload;
    },
    popProductRecordsByEmpId: (state) => {
      state.productRecordsByEmpId = []
    }
  },
});

export const { pushProductById, popProductById, pushProductRecords, popProductRecords, pushFilterProductRecords, popFilterProductRecords, pushProductRecordsByEmpId,
  popProductRecordsByEmpId } = productSlice.actions;

export const selectProductById = (state) => state.product.productById;

export const selectProductRecords = (state) => state.product.productRecords;

export const selectFilterProductRecords = (state) => state.product.filterProductRecords;

export const selectProductRecordsByEmpId = (state) => state.product.productRecordsByEmpId;

export default productSlice.reducer;
